export const API_RESOURCES = {
  management: 'management',
  users: 'users',
  communication: 'communication',
};

export const RESOURCES = {
  admin: `${API_RESOURCES.management}/admin`,
  dashboard: 'dashboard',
  alerts: `${API_RESOURCES.management}/alerts`,
  carriers: `${API_RESOURCES.management}/carriers`,
  countries: `${API_RESOURCES.management}/countries`,
  customers: `${API_RESOURCES.management}/customers`,
  devices: `${API_RESOURCES.management}/devices`,
  profiles: `${API_RESOURCES.management}/profiles`,
  logs: `${API_RESOURCES.management}/logs`,
  applicationVersions: `${API_RESOURCES.management}/applicationVersions`,
  users: `${API_RESOURCES.users}/users`,
  sso: `${API_RESOURCES.users}/users/sso`,
  messagingProfiles: `${API_RESOURCES.communication}/messaging/profiles`,
  settings: 'settings',
  signalR: `${API_RESOURCES.communication}/signalr-backoffice`,
};

/**
 * Build the UPDATE_PASSWORD URL for OIDC flows at runtime.
 * The redirect_uri must match the proxy's real callback route (/client-proxy/callback,
 * see proxy/src/oidc.ts `callbackPath`), which is also what's registered as a valid
 * redirect URI on the Keycloak client.
 * For local dev against a cloud IDP, override the Keycloak host with:
 *   VITE_IDP_BASE_URL=https://esimctrltgdev.northeurope.cloudapp.azure.com
 */
export function getUpdatePasswordUrl(): string {
  const keycloakBase = import.meta.env.VITE_IDP_BASE_URL || window.location.origin;
  const callbackUrl = `${window.location.origin}/client-proxy/callback`;
  return `${keycloakBase}/auth/realms/webbing/protocol/openid-connect/auth?client_id=auth-client&response_type=code&scope=openid&redirect_uri=${encodeURIComponent(callbackUrl)}&kc_action=UPDATE_PASSWORD`;
}
